import type * as React from 'react';

import type { NodeProps } from '@xyflow/react';
import type { Node } from '@xyflow/react';

import type { BaseNodeData, NodeDefinition } from '../../types';

import { ConditionConfig } from './ConditionConfig';
import { ConditionNode, conditionVisualDefinition } from './ConditionNode';
import {
  ConditionConfigType,
  defaultConditionConfig,
  validateConditionConfig,
  getConditionPreviewText,
} from './schema';

export { ConditionNode } from './ConditionNode';
export { ConditionConfig } from './ConditionConfig';
export type { ConditionConfigType } from './schema';

export const conditionDefinition: NodeDefinition<ConditionConfigType> = {
  ...conditionVisualDefinition,
  category: 'flow',
  paletteGroup: 'Flow Control',

  NodeComponent: ConditionNode as unknown as React.ComponentType<
    NodeProps<Node<BaseNodeData>>
  >,
  ConfigComponent: ConditionConfig,

  defaultConfig: () => ({ ...defaultConditionConfig }),
  validateConfig: validateConditionConfig,

  getPreviewText: getConditionPreviewText,
};
